import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const ConfirmBtn = styled(Button)({
  height: "48px",
  lineHeight: "48px",
  maxHeight: "48px",
  color: "#000000",
  fontSize: 14,
  width: "100%",
  fontFamily: "Gilroy-Bold",
  textTransform: "uppercase",
  background: "#14D1B2",
  border: "none",
  borderRadius: "8px",
  "&:hover": {
    background: "#4BF2D6",
    color: "#000000",
  },
});
